import { setRange } from './helpers';

export const setSite = setRange('site');
